<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-02-19 15:46:56
 * @LastEditTime: 2021-06-16 21:50:46
 * @LastEditors: dezhi
 -->
<template>
  <div class="login flex sharing-v">
    <div class="flex-grow-1">
      <a-row
        type="flex"
        justify="center"
        align="middle"
        style="height: calc(100vh - 100px)"
      >
        <a-col>
          <div class="logo"></div>
          <a-card
            title="智能财务师FAI-初级"
            :bordered="true"
            :headStyle="{
              color: '#000',
              fontSize: '18px',
              border: 'none',
              textAlign: 'center',
              marginTop: '10px',
            }"
            :bodyStyle="{
              paddingTop: '0',
              marginTop: '10px',
            }"
            style="
              width: 350px;
              box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
            "
          >
            <a-tabs
              default-active-key="1"
              :animated="false"
              @change="tabsSwitch"
            >
              <a-tab-pane key="1" tab="验证码登录">
                <MsgLogin ref="msgLogin" />
              </a-tab-pane>
              <a-tab-pane key="2" tab="密码登录" force-render>
                <PwdLogin ref="pwdLogin" />
              </a-tab-pane>
            </a-tabs>
          </a-card>
          <a-card
            style="
              margin-top: 35px;
              height: 86px;
              box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
            "
          >
            <div style="display: flex">
              <img
                src="../assets/images/fill.png"
                style="width: 18px; height: 18px"
              /><span style="margin-left: 6px; font-weight: 700"
                >下载打印时间:</span
              >
            </div>
            <div v-if="opentime && opentime != ''">
              <div>{{ opentime }} - {{ endtime }}</div>
            </div>
            <div v-else>
              <div>暂未开放下载打印！</div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <footer class="text-center flex sharing-v">
      沪ICP备16042983号-7 Copyright © 2021 上海管会教育培训有限公司， All Rights
      Reserved
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
// import wx from 'weixin-js-sdk';
import PwdLogin from "../components/login/account-login";
import MsgLogin from "../components/login/msg-login";
import baseConf from "@/assets/js/conf.js";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("account");
export default {
  name: "Login",
  components: {
    PwdLogin,
    MsgLogin,
  },
  data() {
    return {
      tabIdx: 1,
      wxAppid: baseConf.wxAppid,
      opentime: "",
      endtime: "",
    };
  },

  mounted() {
    sessionStorage.clear();
    localStorage.clear();
    this.iscertificate().then((res) => {
      console.log("iscertificate-res：", res.data);
      if (res.data.status && res.data.status == "2000") {
        // console.log("拿到准考证时间");
        // console.log("拿到准考证时间", res.data.data.examTicketStartDate);
        if (
          res.data.data.examTicketStartDate &&
          res.data.data.examTicketEndDate
        ) {
          this.opentime = this.filterDate(res.data.data.examTicketStartDate);
          this.endtime = this.filterDate(res.data.data.examTicketEndDate);
          sessionStorage.setItem(
            "isDuringDate",
            this.isDuringDate(this.opentime, this.endtime)
          );
          // console.log(
          //   "isDuringDate时间",
          //   this.isDuringDate(this.opentime, this.endtime)
          // );
        }
      } else {
        this.$warning({
          content: "系统暂未开放",
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
        });
      }
    });
  },
  methods: {
    ...mapActions(["iscertificate"]),
    tabsSwitch() {
      this.$refs.msgLogin.form.resetFields();
      this.$refs.pwdLogin.form.resetFields();
    },
    filterDate(date1) {
      if (!date1) return;

      var date = new Date(date1);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      let h = date.getHours() + ":";
      let m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      return Y + M + D + h + m + s;
    },
    isDuringDate(beginDateStr, endDateStr) {
      var curDate = new Date().getTime();
      var beginDate = new Date(beginDateStr.replace(/-/g, "/"));
      var endDate = new Date(endDateStr.replace(/-/g, "/"));
      // console.log("beginDateStr时间", beginDateStr);
      // console.log("endDateStr时间", endDateStr);
      // console.log("curDate时间", curDate);
      // console.log("beginDate时间", beginDate);
      // console.log("endDate时间", endDate);
      if (curDate >= beginDate && curDate <= endDate) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style>
.ant-card-head::after {
  clear: both;
  content: "准考证打印" !important;
  margin: 0 auto !important;
  font-weight: 700 !important;
}
.ant-card-head-title {
  padding: 16px 0 0 0 !important;
  font-weight: 700 !important;
}
</style>
<style scoped>
.login {
  min-height: 100vh;
  height: 100%;
  background: url(../assets/images/bg.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.flex-grow-1 {
  flex: 1;
}
.ant-row-flex {
  height: 100%;
}
.logo {
  display: block;
  margin: 20px auto;
  width: 147px;
  height: 90px;
  background: url(../assets/images/login-logo.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.tabs-menu {
  margin-bottom: 25px;
  justify-content: flex-start;
}
.tabs-menu span {
  display: inline-block;
  width: 72px;
  padding-bottom: 10px;
  margin-right: 20px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 25px;
  border-bottom: 3px solid transparent;
  cursor: pointer;
}
span.active {
  border-color: #b01f21;
}
footer {
  height: 100px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  background: #fff;
}
.wx-login {
  display: none;
}
@media (max-width: 768px) {
  .wx-login {
    display: block;
  }
  .logo {
    display: block;
    margin: 0 auto 10px;
    width: 147px;
    height: 90px;
    background: url(../assets/images/login-logo1.png);
    /* background: url("http://www.cgftedu.com/_nuxt/img/3ce2f32.png"); */
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .login {
    min-height: 100vh;
    height: 100%;
    background: none;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
}
</style>
